import React, { useState } from 'react';
import './yearexperience.css';
import { useNavigate } from 'react-router-dom';

const YearsExperience = () => {
    const navigate = useNavigate();
    
    const milestones = [
        { year: "1998", title: "The Beginning", desc: "Operations commenced in financial services." },
        { year: "2006", title: "Banking Era", desc: "Transitioned to Multi-Bank platforms." },
        { year: "2012", title: "Loan Vertical", desc: "Launched distribution network." },
        { year: "2015", title: "Insurance", desc: "Entry into risk management sector." },
        { year: "2023", title: "Wealth Management", desc: "Started dedicated wealth services." },
        { year: "2024", title: "Digital Realty", desc: "App launch & Real Estate entry." },
        { year: "2026", title: "Global Milestone", desc: "Targeting 3.10K CR Licensing." }
    ];

    const [activeIdx, setActiveIdx] = useState(milestones.length - 1);

    return (
        <>
            <section className="kfx-breadcrumb-hero">
                {/* Dark Overlay */}
                <div className="kfx-hero-overlay"></div>

                <div className="kfx-hero-content">
                    <nav className="kfx-breadcrumb">
                        <a href="/" className="kfx-crumb-link">HOME</a>
                        <span className="kfx-crumb-separator">/</span>
                        <span className="kfx-crumb-active">1998</span>
                    </nav>
                    <h1 className="kfx-hero-title">YEAR EXPERIENCE</h1>
                </div>
            </section>

            <div className="kfx-container">
                {/* --- Integrated About Company Section --- */}
                <section className="kfx-about-header">
                    <div className="kfx-about-grid">
                        {/* Image Column */}
                        <div className="kfx-col-image">
                            <div className="kfx-split-container">
                                <img src="./images/yearexperiance/experiance.jpg" alt="Team 1" className="kfx-split-img kfx-img-1" />
                                <div className="kfx-overlap-frame"></div>
                            </div>
                        </div>

                        {/* Content Column */}
                        <div className="kfx-col-content">
                            <span className="kfx-sub-title">|| EXPERIENCE ABOUT COMPANY ||</span>
                            <h2 className="kfx-main-title">Get to know about our company</h2>
                            <p className="kfx-description">
                                Founded by <strong>Rakesh Panchal</strong>, we started with a simple mission: to make financial growth accessible. Today, we stand as a beacon of trust in the industry.
                            </p>
                            <ul className="kfx-features">
                                <li>Strategic Financial Planning & Advice</li>
                                <li>Trusted Industry Expertise since 1991</li>
                                <li>Transparent & Secure Process Management</li>
                                <li>Seamless Digital Wealth Solutions</li>
                            </ul>
                        </div>
                    </div>
                </section>

                <section className="kfx-loan-banner">
                    <div className="kfx-loan-container">
                        {/* Left Side: Image Content */}
                        <div className="kfx-loan-image">
                            <img
                                src="./images/yearexperiance/cta.png"
                                alt="Business Handshake"
                            />
                        </div>

                        {/* Right Side: Red Content Area */}
                        <div className="kfx-loan-content">
                            <div className="kfx-loan-text-wrapper">
                                <span className="kfx-loan-tagline">SIMPLE  /  TRANSPARENT  /  SECURE</span>
                                <h2 className="kfx-loan-title">Get quick business loans</h2>

                                <div className="kfx-loan-action">
                                    <button className="kfx-loan-btn" onClick={() => navigate('/contact-us')}>Apply For Loan</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* --- Interactive Timeline Section --- */}
                <section className="kfx-timeline-wrapper">
                    <div className="kfx-timeline-rail">
                        {milestones.map((item, index) => (
                            <div
                                key={index}
                                className={`kfx-step ${index === activeIdx ? 'is-active' : ''}`}
                                onClick={() => setActiveIdx(index)}
                            >
                                <div className="kfx-step-circle">
                                    <span className="kfx-step-year">{item.year}</span>
                                </div>
                                <div className="kfx-step-label">{item.title}</div>
                            </div>
                        ))}
                    </div>

                    <div className="kfx-detail-display">
                        <div className="kfx-detail-year-bg">{milestones[activeIdx].year}</div>
                        <div className="kfx-detail-inner">
                            <h3>{milestones[activeIdx].title}</h3>
                            <p>{milestones[activeIdx].desc}</p>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default YearsExperience;